import React, { lazy } from 'react';

const TaxTypeListing = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxModule/TaxTypeListing'
  ).then(module => ({
    default: module.TaxTypeListing,
  })),
);

const TaxSchemeListing = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxModule/TaxSchemeListing'
  ).then(module => ({
    default: module.TaxSchemeListing,
  })),
);

const TaxEffectiveDateForm = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxModule/TaxEffectiveDateForm'
  ).then(module => ({
    default: module.TaxEffectiveDateForm,
  })),
);

const TaxSetupListing = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxModule/TaxSetupListing'
  ).then(module => ({
    default: module.TaxSetupListing,
  })),
);

const TaxSetupForm = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxModule/TaxSetupForm'
  ).then(module => ({
    default: module.TaxSetupForm,
  })),
);
const TaxSetupDetail = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxModule/TaxSetupDetail'
  ).then(module => ({
    default: module.TaxSetupDetail,
  })),
);

const taxRoutes = [
  {
    props: { exact: true, path: '/common-settings/tax-type/' },
    component: <TaxTypeListing software="Contract" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-type/:taxTypeID/tax-scheme',
    },
    component: <TaxSchemeListing software="Contract" />,
  },
  {
    props: {
      exact: true,
      path:
        '/common-settings/tax-type/:taxTypeID/tax-scheme/tax-effective-date/add',
    },
    component: <TaxEffectiveDateForm software="Contract" mode="add" />,
  },
  {
    props: {
      exact: true,
      path:
        '/common-settings/tax-type/:taxTypeID/tax-scheme/:taxSchemeID/tax-effective-date/edit',
    },
    component: <TaxEffectiveDateForm software="Contract" mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-type/:taxTypeId/tax-setup/',
    },
    component: <TaxSetupListing software="Contract" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-type/:taxTypeId/tax-setup/add',
    },
    component: <TaxSetupForm software="Contract" mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-type/:taxTypeId/tax-setup/:taxSetupID/edit',
    },
    component: <TaxSetupForm software="Contract" mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-type/:taxTypeId/tax-setup/:taxSetupID/detail',
    },
    component: <TaxSetupDetail software="Contract" />,
  },
];

export default taxRoutes;
